import type { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "@privacy/translations";

export const ConnectionCriticality: FC<{ value: number }> = ({ value }) => {
  const { t } = useTranslation();
  return (
    <Stack direction="row" sx={{ alignItems: "baseline", gap: 0.75 }}>
      <Typography sx={{ fontSize: theme => theme.typography.pxToRem(12), color: theme => theme.palette.text.tertiary }}>
        {t("Classification.Criticality.Label")}
      </Typography>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: theme => theme.typography.pxToRem(14),
          color: theme => theme.palette.text.primary,
        }}
      >
        {value}
      </Typography>
    </Stack>
  );
};
